import {
  ClipboardList,
  PlayCircle,
  PackageCheck,
  Megaphone,
  Package,
  Sparkles,
  Heart,
  ListChecks,
  PartyPopper,
  HandHeart,
} from "lucide-react";

const map = {
  ClipboardList,
  PlayCircle,
  PackageCheck,
  Megaphone,
  Package,
  Sparkles,
  Heart,
  ListChecks,
  PartyPopper,
  HandHeart,
};

export default function getIcon(name) {
  return map[name] || Sparkles;
}
